import React from 'react';
const Page = React.lazy(() => import('pages/FinanceLoan/FinanceLoanPage'));
const permissions = ['FI_LOAN_VIEW', 'FI_LOAN_EDIT', 'FI_LOAN_REVIEW', 'FI_LOAN_POST', 'FI_LOAN_REVERSE'];
export default [
  {
    path: '/finance-loans',
    exact: true,
    name: 'Khoản vay ngân hàng',
    function: permissions,
    any: true,
    component: Page,
  },
  {
    path: '/finance-loans/detail/:id',
    exact: true,
    name: 'Chi tiết khoản vay ngân hàng',
    function: permissions,
    any: true,
    component: Page,
  },
];
